import { ActivatedRoute, Params, Router } from '@angular/router'

/** Navigates to the application root ('/').  Use instead of inline router.navigate(['/']). */
export function navigateToHome(router: Router): Promise<boolean> {
    return router.navigate(['/'])
}

/**
 * Navigates while merging the provided query params into the current URL.
 * Commonly used to persist view state (e.g., selected tab) without losing other params.
 */
export function navigateWithMergedQueryParams(
    router: Router,
    route: ActivatedRoute,
    queryParams: Params,
    options: { replaceUrl?: boolean } = {},
): Promise<boolean> {
    return router.navigate([], {
        relativeTo: route,
        queryParams,
        queryParamsHandling: 'merge',
        replaceUrl: options.replaceUrl ?? true,
    })
}
